export default function PrivacyPolicy() {
  return (
    <main className="legal-page">
      <div className="container legal-container">
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: January 2026</p>

        <section>
          <h2>Our Commitment</h2>
          <p>
            Quit Gooning is built on a simple principle: your data is yours alone.
            We have no interest in collecting, storing, or selling your personal information.
          </p>
        </section>

        <section>
          <h2>No Account Required</h2>
          <p>
            You do not need to create an account, provide an email address, or
            sign in with any service to use this app. There is no login. There is
            no registration.
          </p>
        </section>

        <section>
          <h2>No Cloud Storage</h2>
          <p>
            All data generated by the app — including your progress, streaks,
            and settings — is stored locally on your device. Nothing is uploaded
            to any server.
          </p>
        </section>

        <section>
          <h2>No Tracking or Analytics</h2>
          <p>
            We do not use any analytics services, tracking pixels, cookies, or
            fingerprinting technologies. We do not know who you are, what you do
            in the app, or how often you use it.
          </p>
        </section>

        <section>
          <h2>No Third-Party Data Sharing</h2>
          <p>
            Because we collect no data, there is nothing to share. We do not sell,
            rent, or provide user information to any third party.
          </p>
        </section>

        <section>
          <h2>Data Deletion</h2>
          <p>
            Since all data is stored on your device, you can delete it at any time
            by clearing the app's data or uninstalling the app. We have no
            backups of your information.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            If we update this policy, we will reflect the changes here. Our core
            commitment — no data collection, no tracking, no cloud — will not
            change.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            If you have questions about this privacy policy, please reach out at{' '}
            <a href="mailto:umairali2k181@gmail.com">umairali2k181@gmail.com</a>{' '}
            or call <a href="tel:+923098929098">+923098929098</a>.
          </p>
        </section>
      </div>
    </main>
  );
}
